export default "__VITE_ASSET__CpgJF0hR__"